export const numberFormat = (value) =>
  new Intl.NumberFormat('fil-PH', {
    style: 'currency',
    currency: 'PHP'
  }).format(value);